<template>
  <div class="AddDepartment">
    <div class="content">
      <SpForm ref="departForm" v-model="cmpInfo" @submit="submit">
        <div class="flex-jc-end">
          <SpButton class="mg-r-20" circle-radius="5" type="back" :width="240" :height="70">
            <span class="font-bold font18">{{ $l('back') }}</span>
          </SpButton>
          <SpButton type="primary" circle="5" html-type="submit" :label="$L('submit')" :width="240" :height="70">
            <span class="font-bold font18">{{ $l('Submit') }}</span>
          </SpButton>
        </div>
        <div class="flex-jc-bt main">
          <div class="flex-56 left left-side text-left">
            <SpCard class="card" custom-class="sp-color-bg-4">
              <div class="flex-jc-start">
                <div class="flex-1">
                  <div class="pd-r-80">
                    <div class="">
                      <div class="label-content mg-t-10" style="padding-right: 160px">
                        <p v-required class="fw-bold italic label">{{ $l('DeptOrFunctionalTeam') }}</p>
                        <div class="content flex-al-center flex-jc-start">
                          <div class="flex-1">
                            <SpInput v-model="cmpInfo.name" :validate-reg="/^(?=.*[a-zA-Z])[\w\-().,\' ]{2,64}$/" placeholder="English" height="70" required name="name" type="warn" />
                            <SpInput v-model="cmpInfo.nativeName" placeholder="Native Language " validate-reg="/^(.{2,64})?$/"
                                     style="margin-top: 2px" height="70" name="nativeName" type="warn2" />
                          </div>

                          <div class="icon-panel" />
                        </div>
                      </div>
                    </div>
                    <div class="">
                      <div class="label-content mg-t-10">
                        <p v-required class="fw-bold italic label">{{ $l('CodeName(English)') }}</p>
                        <div class="content flex-al-center flex-jc-start">
                          <div style="width: 257px">
                            <SpInput v-model="codeName" :disabled="codeNameDisabled" name="codeName" height="42" width="257" required :validate-reg="/^[A-Z]{8}$/" :type="codeNameDisabled ? 'gray': 'warn'" />
                          </div>

                          <div class="icon-panel"><span v-if="!cmpInfo.id" class="icon-edit-1 iconfont" @click="codeNameDisabled = !codeNameDisabled" /></div>
                        </div>
                      </div>
                      <p v-triangle class="fw-bold text-left">
                        {{ $l('ContactInformation') }}
                      </p>
                      <div class="label-content">
                        <p v-required class="fw-bold italic label" style="padding-left: 75px">{{ $l('Office Country or SAR and City:') }}</p>
                        <div class="content flex-al-center flex-jc-start">
                          <div class="flex-1 pd-r-10 text-right">
                            <div class="flex-al-center flex-jc-start">
                              <div class="flex-1">
                                <SpSelect v-model="cmpInfo.countryId" height="42" required name="countryId" type="warn" @after-select="searchCity">
                                  <SpSelectOption v-for="item in countrys" :key="item.id" :label="item.name" :value="item.id" />
                                </SpSelect>
                              </div>
                              <div style="width: 30px">
                                —
                              </div>
                            </div>
                          </div>
                          <div class="flex-1">
                            <SpSelect v-model="cmpInfo.cityId" :disabled="!cmpInfo.countryId" required name="cityId" type="warn" height="42" @search="toSearchCity">
                              <SpSelectOption v-for="item in citys" :key="item.id" :label="`${item.name} [${item?.stateCode}]`" :value="item.id" />
                            </SpSelect>
                          </div>
                          <div class="icon-panel" />
                        </div>
                      </div>
                      <div class="label-content" style="margin-top: -14px">
                        <div class="content flex-al-center flex-jc-start">
                          <div class="flex-1 pd-r-10 text-right">
                            <div class="flex-al-center flex-jc-start">
                              <div class="flex-1">
                                {{ cmpInfo.countryCode }}
                              </div>
                              <div style="width: 30px">
                                —
                              </div>
                            </div>
                          </div>
                          <div class="flex-1">
                            <SpInput v-model="cmpInfo.cityCode" class="size-8" width="44" height="24" row="3" name="cityCode" type="warn2" />
                          </div>
                          <div class="icon-panel" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div style="width: 252px">
                  <SpUploadGroup ref="deptLogo"
                                 width="252"
                                 height="324"
                                 file-type="dept/photo"
                                 :max-count="1"
                                 :upload-after-select="!!cmpInfo.id"
                                 up-title="Office photo"
                                 :business-id="cmpInfo.id"
                                 :default-files="deptLogo" />
                </div>
              </div>
              <div class="label-content mg-t-20">
                <p v-required class="fw-bold italic label">{{ $l('EmailAddress') }}</p>
                <div class="content flex-al-center flex-jc-start">
                  <div class="flex-1 text-right">
                    <div class="flex-al-center flex-jc-start">
                      <SpInput v-model="cmpInfo.emails" name="emails" height="42" required type="warn" />
                    </div>
                  </div>
                </div>
              </div>

              <div class="flex-jc-start">
                <div class="flex-1">
                  <div class="">
                    <div class="label-content mg-t-20">
                      <div class="content flex-al-center flex-jc-start">
                        <div style="width: 100px" class="italic">
                          {{ $l('Skype') }}
                        </div>
                        <div class="flex-1 text-right">
                          <div class="flex-al-center flex-jc-start">
                            <SpInput v-model="cmpInfo.skype" height="42" name="skype" :validate-reg="/^(?=.*[A-Za-z\d\s]).{4,32}$/" type="warn2" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="flex-jc-start">
                <div class="flex-1">
                  <div class="pd-r-80">
                    <div class="label-content mg-t-20">
                      <div class="content flex-al-center flex-jc-start">
                        <div style="width: 100px" class="italic">
                          {{ $l('TELREP') }}
                        </div>
                        <div class="flex-1 text-right">
                          <div class="flex-al-center flex-jc-start">
                            <div class="tel-area" :style="'width:'+telAreaCodeWidth+'px'" style="height: 40px; font-size: 14px;">
                              {{ telAreaCode }}
                            </div>
                            <SpInput v-model="cmpInfo.telRepMain" height="40" class="flex-1" name="telRepMain" :validate-reg="/^(?=.*[A-Za-z\d\s]).{4,32}$/" type="warn2" />
                          </div>
                        </div>
                        <div class="icon-panel" />
                      </div>
                    </div>
                    <div class="label-content mg-t-20">
                      <div class="content flex-al-center flex-jc-start">
                        <div style="width: 100px" class="italic">
                          {{ $l('TELDIR') }}
                        </div>
                        <div class="flex-1 text-right">
                          <div class="flex-al-center flex-jc-start">
                            <div class="tel-area" :style="'width:'+telAreaCodeWidth+'px'" style="height: 40px; font-size: 14px;">
                              {{ telAreaCode }}
                            </div>
                            <SpInput v-model="cmpInfo.telDirMain" height="40" class="flex-1" name="telDirMain" type="warn2" />
                          </div>
                        </div>
                        <div class="icon-panel" />
                      </div>
                    </div>
                    <div class="label-content mg-t-20">
                      <div class="content flex-al-center flex-jc-start">
                        <div style="width: 100px" class="italic">
                          {{ $l('FAX') }}
                        </div>
                        <div class="flex-1 text-right">
                          <div class="flex-al-center flex-jc-start">
                            <div class="tel-area" :style="'width:'+telAreaCodeWidth+'px'" style="height: 40px; font-size: 14px;">
                              {{ telAreaCode }}
                            </div>
                            <SpInput v-model="cmpInfo.faxMain" height="40" class="flex-1" name="faxMain" type="warn2" />
                          </div>
                        </div>
                        <div class="icon-panel" />
                      </div>
                    </div>

                    <div class="label-content mg-t-20">
                      <div class="italic mg-b-10">
                        {{ $l('OtherContacts') }}
                      </div>
                      <div class="content flex-al-center flex-jc-start">
                        <div class="flex-1 text-right">
                          <div class="flex-al-center flex-jc-start">
                            <SpInput v-model="cmpInfo.others" type="warn2" name="others" text-type="textArea" row="6" />
                          </div>
                        </div>
                        <div class="icon-panel" />
                      </div>
                    </div>
                  </div>
                </div>
                <div style="width: 252px" />
              </div>
            </SpCard>
          </div>
          <div class="flex-42 pd-l-20 sp-color-bg-4 text-left">
            <DeptOtherInfo :dept-info="cmpInfo" :company-info="nodeDetail.defaultCorp" :master-node-default-corp="masterNodeDefaultCorp" />
          </div>
        </div>
      </SpForm>
    </div>
  </div>
</template>

<script type='text/ecmascript-6'>
import spTagGroup from '@/components/common/SpTagGroup'
import spTag from '@/components/common/SpTag'

import SpForm from '@/components/common/SpForm'
import SpInput from '@/components/common/SpInput'
import spRadio from '@/components/common/SpRadio'
import spRadioGroup from '@/components/common/SpRadioGroup'
import SpSelect from '@/components/common/SpSelect'
import SpSelectOption from '@/components/common/SpSelectOption'
import SpCard from '@/components/common/SpCard'
import SpUploadGroup from '@/components/common/SpUploadGroup.vue'
import {
  editEnterpriseDeptApi,
  getEnterpriseNodeDetailApi,
  getEnterpriseDeptDetailApi, getEnterpriseStructure
} from '@/request/APIs/company'
import SpMessage from '@/components/common/SpMessage'
import { nextTick } from '@vue/runtime-core'
import { getCountrySpareList, searchAddress } from '@/request/APIs/common'
import DeptOtherInfo from '@/components/company/addDepartment/DeptOtherInfo'
import SpButton from '@/components/common/SpButton'
import _includes from 'lodash/includes'
export default {
  name: 'AddDepartment',
  nameSpace: 'company.AddDepartment',
  components: {
    DeptOtherInfo,
    SpForm,
    spTagGroup,
    spTag,
    SpInput,
    spRadio,
    spRadioGroup,
    SpSelect,
    SpSelectOption,
    SpCard,
    SpUploadGroup,
    SpButton
  },

  data () {
    return {
      type: 'BasicInformation', // 给 sp-tag 设置一个初始的默认选中的位置
      cmpInfo: {
      },

      nodeDetail: {
        defaultCorp: {}
      },

      masterNodeDefaultCorp: {},
      countrys: [],
      selectedCountryInfo: {},
      citys: [],
      selectedCityInfo: {},
      codeNameDisabled: true
    }
  },

  computed: {
    routerQuery () {
      return this.$route.query
    },

    codeName: {
      get () {
        let codeName = this.cmpInfo.codeName || this.cmpInfo.name ? this.cmpInfo.name.toUpperCase().replace(/[\s,\d]*/g, '') : ''
        codeName = codeName.replace(/[^a-zA-Z]/g, '')
        codeName = codeName.length > 8 ? codeName.slice(0, 8) : codeName + new Array(8 - codeName.length < 0 ? 0 : 8 - codeName.length).fill('X').join('')
        return codeName
      },

      set (nv) {
        this.cmpInfo.codeName = nv
      }
    },

    telAreaCode () {
      if (this.cmpInfo.cityCode && this.cmpInfo.countryCode) {
        return this.cmpInfo.countryCode.includes('+') ? `${this.cmpInfo.countryCode} ${this.cmpInfo.cityCode}` : `+${this.cmpInfo.countryCode} ${this.cmpInfo.cityCode}`
      } else if (this.cmpInfo.countryCode && !this.cmpInfo.cityCode) {
        return this.cmpInfo.countryCode.includes('+') ? `${this.cmpInfo.countryCode}` : `+${this.cmpInfo.countryCode}`
      } else {
        return ''
      }
    },

    telAreaCodeWidth () {
      return this.telAreaCode.length * 8 > 60 ? this.telAreaCode.length * 8 : 60
    },

    deptLogo () {
      const list = []
      if (this.cmpInfo.photo) {
        const files = this.cmpInfo.photo
        Object.keys(files).forEach(key => {
          list.push({
            type: 'img',
            url: files[key],
            id: key
          })
        })
      }
      return list
    }
  },

  watch: {
    'cmpInfo.countryId': {
      handler (newV, oldV) {
        if (!newV) {
          this.cmpInfo.cityId = null
        }
      }
    }
  },

  created () {
    // 获取国家列表
    if (localStorage.getItem('countrysSpare')) {
      this.countrys = JSON.parse(localStorage.getItem('countrysSpare'))
    } else {
      getCountrySpareList().then((res) => {
        this.countrys = res.data
        localStorage.setItem('countrysSpare', JSON.stringify(res.data))
      })
    }
    this.cmpInfo.nodeId = parseInt(this.routerQuery.nodeId)
    this.getNodeDetail()
    this.getEnterpriseDeptDetail()
  },

  mounted () {

  },

  methods: {
    submit (params) {
      const info = params.data
      if (params.validate) {
        info.nodeId = this.routerQuery.nodeId
        info.id = this.cmpInfo.id
        if (this.cmpInfo.cityCode) {
          info.telRep = info.telRepMain ? `${this.cmpInfo.countryCode}-${this.cmpInfo.cityCode}-${info.telRepMain}` : ''
          info.telDir = info.telDirMain ? `${this.cmpInfo.countryCode}-${this.cmpInfo.cityCode}-${info.telDirMain}` : ''
          info.fax = info.faxMain ? `${this.cmpInfo.countryCode}-${this.cmpInfo.cityCode}-${info.faxMain}` : ''
        } else {
          info.telRep = info.telRepMain ? `${this.cmpInfo.countryCode}-${info.telRepMain}` : ''
          info.telDir = info.telDirMain ? `${this.cmpInfo.countryCode}-${info.telDirMain}` : ''
          info.fax = info.faxMain ? `${this.cmpInfo.countryCode}-${info.faxMain}` : ''
        }
        info.identity = this.nodeDetail.defaultCorp.identity
        delete info.telRepMain
        delete info.telDirMain
        delete info.faxMain
        editEnterpriseDeptApi(info).then(res => {
          if (res.code === 1) {
            SpMessage({
              message: res.message,
              type: 'success'
            })
            this.cmpInfo.id = this.cmpInfo.id || res.data.id
            this.$router.push({
              name: 'addDepartment',
              query: {
                nodeId: this.cmpInfo.nodeId,
                id: this.cmpInfo.id
              }
            })
            getEnterpriseStructure().then(res => {
              localStorage.setItem('EnterpriseStructure', JSON.stringify(res.data))
            })
            // 上传文件
            nextTick(() => {
              params.uploadAllFile().then(() => {

              }).catch(e => {
                SpMessage.error('File upload failed!')
              })
            })
          }
        })
      } else {
        SpMessage({
          message: 'The format of the information filled in is incorrect. The verification failed. Please check',
          type: 'error'
        })
      }
    },

    // 获取节点详情
    getNodeDetail () {
      if (this.routerQuery.nodeId) {
        getEnterpriseNodeDetailApi(this.routerQuery.nodeId).then(res => {
          this.nodeDetail = res.data
        })
      }
    },

    // 获取部门详情
    getEnterpriseDeptDetail () {
      if (this.routerQuery?.id) {
        getEnterpriseDeptDetailApi(this.routerQuery.id).then(res => {
          this.cmpInfo = res.data
          this.masterNodeDefaultCorp = this.cmpInfo?.masterNode?.defaultCorp

          const telRep = res.data.telRep.split('-')

          // let code = res.data.countryCode + '-'
          // if (res.data.cityCode) {
          //   code += res.data.cityCode + '-'
          // }
          // console.log('cpde ' + code)
          // this.cmpInfo.telRepMain = res.data.telRep.replace(code, '')

          if (telRep.length === 4 || telRep.length === 3) {
            this.cmpInfo.telRepMain = telRep[2]
          } else if (telRep.length === 2) {
            this.cmpInfo.telRepMain = telRep[1]
          }

          const telDir = res.data.telDir.split('-')
          if (telDir.length === 3) {
            this.cmpInfo.telDirMain = telDir[2]
          } else if (telDir.length === 2) {
            this.cmpInfo.telDirMain = telDir[1]
          }

          const fax = res.data.fax.split('-')

          if (fax.length === 3) {
            this.cmpInfo.faxMain = fax[2]
          } else if (fax.length === 2) {
            this.cmpInfo.faxMain = fax[1]
          }

          searchAddress({ type: 'city', page: 1, cid: this.cmpInfo.countryId, keyWord: '' }).then(res => {
            if (this.cmpInfo.city && !_includes(res.data.map(item => item.id), this.cmpInfo.cityId)) {
              this.citys = [...res.data, this.cmpInfo.city]
            } else {
              this.citys = res.data
            }
          })
        })
      }
    },

    // 根据国家Id获取城市
    searchCity (countryId) {
      this.cmpInfo.cityId = null
      this.selectedCityInfo = {}
      this.selectedCountryInfo = this.countrys.find(c => c.id === countryId)
      // 用于签名档显示
      this.cmpInfo.country = this.selectedCountryInfo
      this.cmpInfo.countryCode = this.selectedCountryInfo.phonecode
      searchAddress({ type: 'city', page: 1, cid: countryId, keyWord: '' }).then(res => {
        this.citys = res.data
      })
    },

    // 获取所选城市内容
    getCityInfo (cityId) {
      this.selectedCityInfo = this.citys.find(c => c.id === cityId)
      // 用于签名档显示
      this.cmpInfo.city = this.selectedCityInfo
    },

    toSearchCity (key) {
      searchAddress({ type: 'city', page: 1, cid: this.cmpInfo.countryId, keyWord: key }).then(res => {
        this.citys = res.data
      })
    }
  }
}
</script>

<style scoped lang='less'>
.AddDepartment{
  .icon-edit-1{
    font-size: 24px;
  }
  >.content{
    padding: @gap @gap @gap @gap*2;
  }
  .reminder,.reminder2{
    background: #F6F6F6;
    opacity: 0.6;
    text-align: left;
    text-indent: 2em;
  }
  .reminder2{
    text-indent: 0em;
  }

}

.label-content{
  margin-bottom: 16px;
  .label{
    margin: 0;
    position: relative;
    z-index: 99;
  }
  .content{
    margin-top: -4px;
  }
  .icon-panel {
    width: 30px;
    text-align: right;
  }
}
.tel-area{
  height: 42px;
  line-height: 42px;
  width: 100px;
  font-size: 14px;
  text-align: left;
  background-color: #efefef;
  padding: 0 4px;
  word-wrap: break-word;
  white-space: nowrap;
}
</style>

<style lang="less">
.SpInput{
  &.size-8{
    input {
      text-align: center;
      text-indent: 0;
      font-size: 8px;
    }
  }
}
</style>
